import { createMarkdownElement } from './createMarkdownElement';

const MarkdownH2 = createMarkdownElement('h2', 'md__h2');
export { MarkdownH2 };
